module.exports = __webpack_public_path__ + "static/media/7_cam.12679dd5.png";